import AppInstallPrompt from "./app-install-prompt";

const element = document.querySelector("[data-app-install-prompt]");

if (element) {
	const options = {
		installButton: element.querySelector(element.dataset.appInstallPromptInstallButtonSelector),
		dismissButton: element.querySelector(element.dataset.appInstallPromptDismissButtonSelector),
		cookieApi: element.dataset.appInstallPromptCookieApi,
		cookieId: element.dataset.appInstallPromptCookieId
	};
	const instance = new AppInstallPrompt(element, options);
	element.instance = instance;
}



// WEBPACK FOOTER //
// ./project/client/src/core/components/app-install-prompt/index.js